import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

export default class QuoteSlider {
    constructor() {
        document.querySelectorAll('.js-quote-slider').forEach((root) => {
            const el = root.querySelector('.js-quote-slider__swiper');

            if (!el) return;

            new Swiper(el, {
                a11y: true,
                autoHeight: true,
                modules: [A11y, Navigation],
                navigation: {
                    nextEl: root.querySelector('.js-quote-slider__nav.is-next'),
                    prevEl: root.querySelector('.js-quote-slider__nav.is-prev'),
                    disabledClass: 'is-disabled',
                },
                slidesPerGroup: 1,
                slidesPerView: 1,
                spaceBetween: 0,
            });
        });
    }
}
